import React, { useState, useEffect } from "react";
import { fetchKindsPcInfo, fetchKindSumRecommend } from "@Services/kindsum";
import { useQuery } from "react-query";

interface IProps {}

interface IRecommendData {
  author: string;
  description: string;
  id: number;
  likes: number;
  link: string;
  playTime: number;
  slug: string;
  startTime: string;
  subscript: string;
  thumb: string;
  thumbList: string[];
  title: string;
  type: number;
  verticalThumb: string;
  views: number;
}

const FrontPageNews: React.FC<IProps> = ({}) => {
  const { data = [] } = useQuery<Array<IRecommendData>>([`fetchKindSumRecommend`, window.query_kind_id], async () => {
    const res: { data; status } = await fetchKindSumRecommend({ kindId: window.query_kind_id });
    return res?.status === 12000 ? res?.data?.items : [];
  });

  if (data?.length === 0) {
    return <></>;
  }

  return (
    <div
      className={"w-282 h-410 bg-[#fff] rounded-4 px-8 pt-8 flex flex-col"}
      style={{ boxShadow: "0px 4px 20px 0px rgba(50,100,255,0.10)" }}
    >
      <a
        href={data[0].link}
        id={`${[1, 2].includes(data[0].type) ? "TopHearderArticle" : "TopHearderMovies"}`}
        className='border-0 border-b-1 border-solid border-[#e8e8e8b3] pb-10'
        target='_blank'
      >
        <div className={`w-266 relative mb-10 ${[1, 2].includes(data[0].type) ? "h-176" : "h-150"}`}>
          <img src={data[0].thumb} alt='' className={`w-full h-full`} />
          {data[0].type === 3 && (
            <img
              className='w-56 h-56 absolute top-0 left-0 right-0 bottom-0 m-auto'
              src='https://photo.8891.com.tw/2024/06/20/1718863650947819.png'
              alt=''
            />
          )}
        </div>
        <p className='line-clamp-2 text-[#333333] text-16 font-medium leading-20'>{data[0].title}</p>
      </a>

      <div className={`flex flex-col justify-between flex-auto ${[1, 2].includes(data[0].type) ? "py-12" : "py-20"}`}>
        {data
          .filter((_, index) => index !== 0)
          .map((item, inx) => (
            <a
              key={inx}
              id={`${
                [1, 2].includes(item.type) ? "TopListArticle" : item.type === 3 ? "TopListMovies" : "TopListShorts"
              }`}
              className='max-h-40 relative'
              href={item.link}
              target='_blank'
            >
              <img
                src={`${
                  [1, 2].includes(item.type)
                    ? "https://photo.8891.com.tw/2024/06/20/1718849486123770.png"
                    : "https://photo.8891.com.tw/2024/06/20/1718849486130606.png"
                }`}
                alt=''
                className='w-16 h-16 inline-block absolute top-0 left-0'
              />
              <p className='text-[#666666] text-14 line-clamp-2 indent-22'>{item.title}</p>
            </a>
          ))}
      </div>
    </div>
  );
};

export default FrontPageNews;
